import { Component, HostListener } from '@angular/core';
import { ClientService } from '../../services/client/client.service';
import { environment } from 'src/environments/environment';
import { Client } from 'src/app/model/client';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css'],
})
export class ClientComponent {
  constructor(private clientService: ClientService) {}

  clients: Client[] = [];
  clientsImages: string[] = [];
  isMobile: boolean = false;
  activeDotIndex: number = 0;

  responsiveOptions = [
    { breakpoint: '1024px', numVisible: 3, numScroll: 1 },
    { breakpoint: '768px', numVisible: 2, numScroll: 1 },
    { breakpoint: '560px', numVisible: 3, numScroll: 3 },
  ];

  get totalDots(): number {
    return Math.ceil(this.clients.length / 3);
  }

  get dotsArray(): number[] {
    return Array.from({ length: this.totalDots });
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 560;
  }

  onPageChange(event: any): void {
    this.activeDotIndex = event.page ?? Math.floor(event.first / 3);
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 560;

    this.clientService.getClients().subscribe((res) => {
      this.clientsImages = res.map(
        (client) => environment.apiUrl + client.imageUrl,
      );
      this.clients = res.map((client) => ({
        ...client,
        imageUrl: environment.apiUrl + client.imageUrl,
        link: client.link
          ? client.link.startsWith('http')
            ? client.link
            : 'https://' + client.link
          : '#',
      }));
    });
  }
}
